<div>
  <mat-icon *ngIf="isVisible"
            matTooltip="{{ message }}"
            matTooltipPosition="after"
            [ngClass]="iconClass">{{ iconName }}
  </mat-icon>
</div>
